import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import {
  getSectionLayoutZones,
  getInstalledModuleIds,
  getInstallableModuleTypes,
} from '../../../../selectors/layout';
import { addModule } from '../../../../actions/layout';
import { Props } from './ZoneGroup';

type StateProps = Pick<Props, 'isCurrentUserProfileOwner' | 'zones'>;
type DispatchProps = Pick<Props, 'addModule'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = (
  state,
  props
) => {
  const zones = Object.keys(getSectionLayoutZones(state, props.section)).reduce(
    (result, zone) => {
      result[zone] = {
        installedModuleIds: getInstalledModuleIds(state, props.section, zone),
        installableModuleTypes: getInstallableModuleTypes(
          state,
          props.section,
          zone
        ),
      };
      return result;
    },
    {}
  );
  return {
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    zones,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (
  dispatch,
  ownProps
) => ({
  addModule: (zone, moduleType, position) =>
    ownProps.section &&
    dispatch(
      addModule({ section: ownProps.section, zone, moduleType, position })
    ),
});

export default connect(mapStateToProps, mapDispatchToProps);
